import gql from 'graphql-tag'

import { SchoolTuitionBillingPolicyFieldsFragment } from 'main/gql/schoolTuitionBillingPolicy'
import { SchoolTuitionProgramFieldsFragment } from 'main/gql/schoolTuitionProgram'

export const DETAILED_PRICING_MODAL_QUERY = gql`
  query DetailedPricingModal($schoolId: Int!) {
    school(id: $schoolId) {
      id
      shortname
      tuitionBillingPolicy {
        ...SchoolTuitionBillingPolicyFields
      }
    }
    schoolTuitionPrograms(schoolId: $schoolId, onlyDisplayed: true) {
      ...SchoolTuitionProgramFields
    }
  }

  ${SchoolTuitionProgramFieldsFragment}
  ${SchoolTuitionBillingPolicyFieldsFragment}
`
